export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.707 7.293a1 1 0 010 1.414l-6 6-1.414-1.414L9.586 8 4.293 2.707l1.414-1.414 6 6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};